// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2Qqt9","title":"ClientReferral_title__9BrRr","itemText":"ClientReferral_itemText__1IcvJ"};